import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusSuccessCircle.tsx
const IconApplicationStatusSuccessCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666m-.831-5 5.891-5.892-1.178-1.179-4.713 4.715L6.81 8.619 5.633 9.797z"
	})]
});
var IconApplicationStatusSuccessCircle_default = forwardRef(IconApplicationStatusSuccessCircle);
//#endregion
export { IconApplicationStatusSuccessCircle_default as default };
